exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#errorPopup {\n  width: 400px;\n  height: 180px;\n}\n#errorPopup .error-body {\n  height: calc(100% - 130px);\n  margin: 20px;\n}", "", {"version":3,"sources":["C:/Users/Nokia/Documents/code/prod/mcFrontend2/src/components/common/error_popup.vue"],"names":[],"mappings":";AAAA;EACE,aAAa;EACb,cAAc;CACf;AAED;EACE,2BAA2B;EAC3B,aAAa;CACd","file":"error_popup.vue","sourcesContent":["#errorPopup {\n  width: 400px;\n  height: 180px;\n}\n\n#errorPopup .error-body {\n  height: calc(100% - 130px);\n  margin: 20px;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":true,"importLoaders":2}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7bc42321","scoped":false,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":54}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/error_popup.vue
// module id = htY0
// module chunks = 1